import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Menu, X, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

const links = [
  { to: "/", label: "Start" },
  { to: "/ueber-lactoseintoleranz", label: "Über Lactoseintoleranz" },
  { to: "/mythen-und-fakten", label: "Mythen & Fakten" },
  { to: "/ernaehrung", label: "Ernährung" },
  { to: "/artikel", label: "Artikel" },
  { to: "/wissenschaft", label: "Wissenschaft" },
  { to: "/warum-laclive", label: "Warum LacLive" },
  { to: "/faq", label: "FAQ" },
  { to: "/kontakt", label: "Kontakt" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const doLogout = async () => {
    await logout();
    nav("/");
  };

  return (
    <header className="glass-nav sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img src="/laclive-logo-sm.webp" alt="LacLive - naturally tolerant" className="h-10 w-auto" />
        </Link>
        <nav className="hidden lg:flex items-center gap-1">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `px-3 py-2 text-sm font-medium rounded-full transition-colors ${isActive ? "text-emerald-700 bg-emerald-50" : "text-slate-600 hover:text-slate-900 hover:bg-slate-100"}`
              }
              data-testid={`nav-link-${l.to.replace(/\//g, "") || "home"}`}
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          {user && user !== false ? (
            <>
              {user.role === "admin" && (
                <Link to="/admin" className="text-sm font-medium text-slate-700 hover:text-emerald-700" data-testid="nav-admin">
                  Admin
                </Link>
              )}
              <Link to="/plan" className="text-sm font-medium text-slate-700 hover:text-emerald-700" data-testid="nav-plan">
                Mein Plan
              </Link>
              <Button onClick={doLogout} variant="outline" className="rounded-full btn-lift" data-testid="nav-logout">
                <LogOut className="w-4 h-4 mr-1" /> Abmelden
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-slate-700 hover:text-emerald-700" data-testid="nav-login">Anmelden</Link>
              <Link to="/paywall" data-testid="nav-cta">
                <Button className="rounded-full bg-emerald-600 hover:bg-emerald-700 btn-lift text-white">
                  Ernährungsplan holen
                </Button>
              </Link>
            </>
          )}
        </div>
        <button
          className="lg:hidden p-2 rounded-lg hover:bg-slate-100"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menü"
        >
          {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden border-t border-slate-200 bg-white">
          <div className="px-6 py-3 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink key={l.to} to={l.to} end={l.to === "/"} onClick={() => setOpen(false)}
                className={({ isActive }) => `px-3 py-2 text-sm rounded-lg ${isActive ? "text-emerald-700 bg-emerald-50" : "text-slate-700 hover:bg-slate-100"}`}>
                {l.label}
              </NavLink>
            ))}
            <div className="border-t border-slate-200 mt-2 pt-2 flex flex-col gap-2">
              {user && user !== false ? (
                <>
                  {user.role === "admin" && (
                    <Link to="/admin" onClick={() => setOpen(false)} className="px-3 py-2 text-sm text-slate-700">Admin</Link>
                  )}
                  <Link to="/plan" onClick={() => setOpen(false)} className="px-3 py-2 text-sm text-slate-700">Mein Plan</Link>
                  <button onClick={doLogout} className="px-3 py-2 text-sm text-left text-slate-700">Abmelden</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setOpen(false)} className="px-3 py-2 text-sm text-slate-700">Anmelden</Link>
                  <Link to="/paywall" onClick={() => setOpen(false)} className="px-3 py-2 text-sm text-emerald-700 font-medium">Ernährungsplan holen</Link>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
